@if (isLoading) {
  <div>
    <div class="loader__container">
      <h2>Loading</h2>
      <div class="loader"></div>
    </div>
  </div>
}
@if (documentIsLocked) {
  <app-locked-takeover
    [lastLockedBy]="reviewQueueItem.lastLockedBy"
  ></app-locked-takeover>
}

@if (!isLoading) {
  <div class="full-container">
    <app-digitization-top-nav
      [document]="reviewQueueItem"
      (saveMethod)="save()"
      (nextMethod)="next()"
      >
      @if (useAzureEarlyClassificationUI && translationAvailable) {
        <div header-action class="toggler translate-toggle">
          <label>Translate to English</label>
          <i class="fas"
            [ngClass]="{ 'fa-toggle-off': viewInNativeLanguage, 'fa-toggle-on': !viewInNativeLanguage }"
            (click)="swapLanguage()"
          ></i>
        </div>
      }
      <!-- Old layout controls (flag OFF) -->
      @if (!useAzureEarlyClassificationUI) {
        <div>
          <div class="toggler">
            <span>Captured Tables</span>
            <i class="fas" (click)="toggleCapturedTablesFilter()"
              [ngClass]="{ 'fa-toggle-off': !showCapturedTablesOnly, 'fa-toggle-on': showCapturedTablesOnly}"
            ></i>
          </div>
        </div>
        <div>
          <div class="toggler">
            <span>View Selected Page</span>
            <i class="fas" (click)="toggleBoxDrawing()"
            [ngClass]="{'fa-toggle-off': !isBoxDrawingShown, 'fa-toggle-on': isBoxDrawingShown}"></i>
          </div>
        </div>
      }
      @if (useAzureEarlyClassificationUI) {
      }
      <div>
        <div class="d-flex flex-row align-items-center flex-wrap">
          <label class="currency d-flex align-items-center">Set Currency </label>
          <select class="form-select w-auto" (change)="changeCurrency($event.target.value)">
            @for (currency of supportedCurrencies; track currency) {
              <option [value]="currency.key"
                [selected]="currency.key === this.documentFile.currency">
                {{ currency.key }} ({{ currency.symbol }})
              </option>
            }
          </select>
        </div>
      </div>
    </app-digitization-top-nav>
    <!-- OLD LAYOUT (flag OFF): existing 2-pane -->
    @if (!useAzureEarlyClassificationUI) {
      <div class="main-wrapper" #wrapper>
        @if (_sharedDataService.shouldShowManualReviewSidebar) {
          <app-maximized-sidebar
            [stepHeader]="stepHeader"
            [steps]="steps"
            [tipsBody]="tipsBody"
            [fullGif]="fullGif"
            [title]="'Table Identification'"
            (toggleSidebar)="toggleStepsToSuccess()">
          </app-maximized-sidebar>
        }
        <app-table-drawing-page
          [allowOnlyOneBox]="false"
          [pageImages]="pagesToShow"
          [currentBoxesByPage]="tablesByPage"
          [(showBoxDrawing)]="isBoxDrawingShown"
          (boxesChanged)="boxesChanged($event)"
        ></app-table-drawing-page>
      </div>
    }
    <!-- NEW LAYOUT (flag ON): 3-pane -->
    @if (useAzureEarlyClassificationUI) {
      <div class="main-wrapper redesigned">
        <!-- Left: Document view (thumbnails + viewer) -->
        <div class="document-view-left">
          <!-- Unified document view header -->
          <div class="document-view-header">
            <div class="header-left-controls">
              <app-pdf-search
                [searchText]="searchText"
                [searchPerformed]="searchPerformed"
                [searchLoading]="searchLoading"
                [currentMatchNumber]="currentMatchNumber"
                [totalMatches]="totalMatches"
                [disabled]="!documentFile?.id"
                [searchError]="searchError"
                [matchNote]="currentMatchNote"
                (searchTextChange)="onSearchTextChange($event)"
                (searchSubmit)="onSearchSubmit()"
                (goToPrevious)="goToPreviousMatch()"
                (goToNext)="goToNextMatch()"
                (clearSearch)="clearSearch()"
              ></app-pdf-search>
              <div class="toggler captured-toggle">
                <span>Captured Tables</span>
                <i class="fas toggle-icon" (click)="toggleCapturedTablesFilter()"
                  [ngClass]="{ 'fa-toggle-off': !showCapturedTablesOnly, 'fa-toggle-on': showCapturedTablesOnly }"
                ></i>
              </div>
            </div>
            <div class="header-right-controls">
              <div class="pagination-controls">
                <span class="page-label">Page</span>
                <input
                  type="number"
                  class="page-number-input"
                  [value]="activePageTrueIndex + 1"
                  min="1"
                  [max]="documentFile?.pageImages?.length || 1"
                  (change)="goToPage($event)"
                  (keydown.enter)="goToPage($event)"
                  />
                <span class="page-total">of {{ documentFile?.pageImages?.length || 0 }}</span>
                <div class="page-nav-stack">
                  <button class="btn-page-nav" (click)="goToPrevPage()" [disabled]="activePageTrueIndex === 0">
                    <i class="fas fa-arrow-up"></i>
                  </button>
                  <button class="btn-page-nav" (click)="goToNextPage()" [disabled]="activePageTrueIndex >= (documentFile?.pageImages?.length || 1) - 1">
                    <i class="fas fa-arrow-down"></i>
                  </button>
                </div>
              </div>
              <div class="zoom-controls">
                <span class="zoom-percentage">{{ mathFloor(imgScale * 100) }}%</span>
                <i class="fas fa-search-plus hover icon" (click)="zoomIn()"></i>
                <i class="fas fa-search-minus hover" (click)="zoomOut()"></i>
              </div>
            </div>
          </div>
          <!-- Content area: thumbnails + viewer side by side -->
          <div class="document-view-content">
            <!-- Thumbnail sidebar -->
            <div class="thumbnail-sidebar">
              <div class="thumbnail-sidebar-body" appImgIntersectionObxList>
                @for (page of filteredPagesToShow; track trackByPageIndex($index, page)) {
                  <div
                    class="sidebar-thumbnail-item fs-block fs-exclude"
                    appImgIntersectionObx
                    #intersection="intersection"
                    #sidebarThumbnail
                    [class.active]="page.pageIndex === activePageTrueIndex"
                    >
                    @if (intersection.hasIntersected) {
                      <app-document-thumbnail
                        [imageWidth]="150"
                        [sourceImageUrl]="page.thumbnail.signedUrl"
                        [page]="page"
                        [boxes]="tablesByPage[page.pageIndex]"
                        [hidePagePrefix]="true"
                        (onImageClickEvent)="activatePageRedesigned($event)"
                      ></app-document-thumbnail>
                    } @else {
                      <div class="sidebar-image-placeholder">
                        ...
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
            <!-- Document viewer -->
            <div class="document-viewer-pane">
              <div class="viewer-body" id="redesigned-box-drawer-scroll-container">
                @if (shouldShowTranslationOverlay()) {
                  <div class="translation-info-banner" role="note">
                    <i class="fas fa-circle-info translation-info-banner__icon"></i>
                    <span class="translation-info-banner__text">Viewing machine translation overlaid on the original document. Hover truncated text (...) to read it in full.</span>
                    <button type="button" class="translation-info-banner__action" (click)="swapLanguage()">Show original</button>
                  </div>
                }
                @if (shouldShowTranslationBanner()) {
                  <div class="translation-unavailable-banner" role="alert">
                    <i class="fas fa-triangle-exclamation translation-unavailable-banner__icon"></i>
                    <span class="translation-unavailable-banner__text">Translation unavailable for this page. Showing the original document below.</span>
                    <button type="button" class="translation-unavailable-banner__retry" (click)="retryTranslation()">Retry</button>
                  </div>
                }
                @if (!viewInNativeLanguage && translationLoading) {
                  <div class="translation-loading" role="status">
                    <div class="loader"></div>
                    <span>Translating…</span>
                  </div>
                }
                @if (isBoxDrawingShown && getCurrentPageImage()?.normalRes?.signedUrl) {
                  <div class="box-drawer-with-highlights">
                    <app-box-drawer
                      id="selected-page-image"
                      [boxes]="tablesByPage[activePageTrueIndex]"
                      [sourceImageUrl]="getCurrentPageImage().normalRes.signedUrl"
                      [allowEdit]="true"
                      [inputImageWidth]="boxDrawingWidth * imgScale"
                      [onlyAllowOneBox]="false"
                      (boxesChanged)="boxesChangedRedesigned({boxes: $event, activePageIndex: activePageTrueIndex})"
                      scrollingContainerElementId="redesigned-box-drawer-scroll-container"
                    ></app-box-drawer>
                    @if (searchPerformed && getDisplayHighlightsForCurrentPage().length > 0) {
                      <div class="search-highlight-overlay"
                        >
                        @for (h of getDisplayHighlightsForCurrentPage(); track trackHighlightById($index, h)) {
                          <div class="text-highlight"
                            [attr.data-highlight-id]="h.id"
                            [class.current]="h.current"
                            [class.cross-layer]="h.crossLayer"
                            [class.outline-only]="h.outlineOnly"
                            [style.left.px]="h.left"
                            [style.top.px]="h.top"
                            [style.width.px]="h.width"
                            [style.height.px]="h.height"
                          ></div>
                        }
                      </div>
                    }
                    @if (shouldShowTranslationOverlay()) {
                      <div class="translation-overlay" [attr.dir]="pageIsRtl ? 'rtl' : 'ltr'">
                        @for (piece of getTranslationPiecesForCurrentPage(); track trackTranslationPieceById($index, piece)) {
                          <span class="translation-piece"
                            [class.translation-piece--paragraph]="piece.isParagraph"
                            dir="auto"
                            [appBsTooltip]="piece.tooltip"
                            [tooltipHtml]="true"
                            [onlyWhenTruncated]="true"
                            tooltipClass="translation-tooltip"
                            [style.left.px]="piece.left"
                            [style.top.px]="piece.top"
                            [style.width.px]="piece.width"
                            [style.height.px]="piece.height"
                            [style.line-height.px]="piece.isParagraph ? null : piece.height"
                            [style.-webkit-line-clamp]="piece.lineClamp"
                            [style.font-size.px]="piece.fontSize"
                            [innerHTML]="piece.html"
                          ></span>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
        <!-- Right pane: Summary panel -->
        <div class="summary-pane">
          <app-table-id-summary-panel
            [tables]="loadedTables"
            [selectedTable]="selectedSummaryTable"
            [activePageIndex]="activePageTrueIndex"
            [mergeStepLabel]="mergeStepLabel"
            [documentFileId]="documentFile?.id"
            (viewTable)="onViewTableFromSummary($event)"
            (reclassifyTable)="onReclassifyTable($event)"
            (unlinkTable)="onUnlinkTable($event)"
          ></app-table-id-summary-panel>
        </div>
      </div>
    }
  </div>
}
